import { makeStyles, Theme } from '@material-ui/core/styles';

const buttonStyle = {
  width: '40%',
  color: 'white',
  maxWidth: 150,
};

export default makeStyles((theme: Theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    borderRadius: 35,
    outline: 0,
    minWidth: 500,
  },
  modalTitle: {
    color: theme.palette.success.main,
    textAlign: 'center',
  },
  greenButton: {
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.success.light,
    },
    ...buttonStyle,
  },
  yellowButton: {
    backgroundColor: theme.palette.warning.main,
    ...buttonStyle,
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  titleInput: {
    width: '100%',
  },
  divisor: {
    margin: theme.spacing(2),
  },
}));
